import React from 'react';
import '../LoveDecision/styles.css';
import Typography from '@mui/material/Typography';
import ItacaWideBlack from '../../../assets/fonts/itaca/Itaca Wide Black.ttf';
import ItacaWideBold  from '../../../assets/fonts/itaca/Itaca-Wide-Bold.otf';
import ItacaWideDemiBold from '../../../assets/fonts/itaca/Itaca-Wide-DemiBold.otf';
import AlbertSansRegular from '../../../assets/fonts/Albert_Sans/AlbertSans-Regular.ttf';

// Importación optimizada de imágenes
import familyImg from '../../../assets/Imagenes/Planes_Futuro/Img1.jpg';
import savingsImg from '../../../assets/Imagenes/Planes_Futuro/Img2.jpg';
import contractImg from '../../../assets/Imagenes/Planes_Futuro/Img3.jpg';
import supportImg from '../../../assets/Imagenes/Planes_Futuro/Img4.jpg';
import TodoDataService from '../../../hooks/services'

// Inyecta todas las fuentes directamente
const fontStyles = `
@font-face {
  font-family: 'Itaca-Wide-Black';
  src: url(${ItacaWideBlack}) format('truetype');
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-Bold';
  src: url(${ItacaWideBold}) format('opentype');
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Itaca-Wide-DemiBold';
  src: url(${ItacaWideDemiBold}) format('opentype');
  font-style: normal;
  font-display: swap;
}

  @font-face {
  font-family: 'Albert-Sans-Regular';
  src: url(${AlbertSansRegular}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
/* Agrega más @font-face para otras variantes si es necesario */
`;

// Crea y añade el elemento style al head
const styleElement = document.createElement('style');
styleElement.innerHTML = fontStyles;
document.head.appendChild(styleElement); 

const LoveDecision = () => {
  const galleryItems = [
    { src: familyImg, alt: "Familia unida protegida por plan funerario" },
    { src: savingsImg, alt: "Ahorro económico con planes a futuro" },
    { src: contractImg, alt: "Documentación legal de contrato seguro" },
    { src: supportImg, alt: "Soporte completo y personalizado" }
  ];

  // Función para redireccionar a WhatsApp
  const redirectToWhatsApp = () => {
    const phoneNumber = '+527227842615';
    const message = encodeURIComponent('Visite su página web; estoy interesado en sus servicios.');
    window.open(`https://wa.me/${TodoDataService.GetNumberCall2()}?text=${message}`, '_blank');
  };

  // Función reutilizable para Typography con soporte responsive
  const renderText = (text, options = {}) => (
    <Typography
      component={options.component || 'p'} // etiqueta HTML que deseas: 'p', 'h1', 'div', etc.
      color={options.color || '#000000'}
      fontSize={options.fontSize || '18px'}
      fontFamily={options.fontFamily || '"Albert Sans", sans-serif'}
      display="inline"
      //fontWeight={options.fontWeight || 400}
      lineHeight="100%"
      sx={{
        '@media (max-width: 480px)': {
          fontSize: options.mobileFontSize || (options.fontSize === '28px' ? '22px' : '14px')
        },
        ...options.sx
      }}
      {...options}
    >
      {text}
    </Typography>
  );

  return (
    <section className="love-decision" aria-labelledby="loveDecisionHeading">
      <div className="content-wrapper">
        <div className="text-content">
          <h1 id="highlight-title">
            {renderText("Una decisión de amor, no de urgencia", {
              component: 'h1',
              color: '#000000',
              fontSize: '16px',
              mobileFontSize: '12px !important',
              fontFamily: "itacaBlack, sans-serif !important",
              // fontWeight: 900
            })}
          </h1>
          
          <p className="main-description">
            {renderText("Adquirir un plan funerario a futuro es un acto de responsabilidad y amor. Es cuidar de ti y de los tuyos, incluso cuando ya no estés.",{
              component: 'p',
              color: '#000000',
              fontSize: '18px',
              mobileFontSize: '16px !important',
              fontFamily: "Albert-Sans-Regular, sans-serif !important",
            })}
            <br/>
            {renderText("Con Columba Funerales, tienes la certeza de estar en manos confiables, con el respaldo y la empatía que mereces.",{
              component: 'p',
              color: '#000000',
              fontSize: '18px',
              mobileFontSize: '16px !important',
              fontFamily: "Albert-Sans-Regular, sans-serif !important",
            })}
          </p>
          
          <p className="highlight-text">
            {renderText("Haz hoy lo que mañana te agradecerán.", {
              component: 'p',
              color: '#D14081',
              fontSize: '28px',
              mobileFontSize: '24px !important',
              fontFamily: "Itaca-Wide-Bold, sans-serif !important",
            })}
          </p>
          
          <button 
            className="button-love" 
            aria-label="Contratar plan funerario ahora"
            onClick={redirectToWhatsApp}
          >
            Compra ahora
          </button>
        </div>
        
        <div className="image-gallery">
          {galleryItems.map((img, index) => (
            <figure key={`gallery-img-${index}`} className="gallery-item">
              <img 
                src={img.src} 
                alt={img.alt} 
                loading={index > 1 ? "lazy" : "eager"} 
                width={280} 
                height={180} 
                decoding="async" 
              />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(LoveDecision);